import type { TelemetryClient } from "../core/client.js";
import type { TelemetryBindingsSource } from "./bindings-source.js";
import { TELEMETRY_CLIENT_TOKEN, TELEMETRY_SERVER_TOKEN } from "./tokens.js";

export interface TelemetryTokens {
  client: string;
  server: string;
  clientSymbol: typeof TELEMETRY_CLIENT_TOKEN;
  serverSymbol: typeof TELEMETRY_SERVER_TOKEN;
}

/**
 * User-injectable module — framework adapters attach via `createTelemetry({ platform })` after init.
 */
export interface TelemetryModule {
  readonly tokens: TelemetryTokens;
  readonly registry: TelemetryBindingsSource;
  getClient(): TelemetryClient | undefined;
  getServer(): TelemetryClient | undefined;
  resolveBindings(): Record<string, TelemetryClient>;
}

export function createModuleFromRegistry(
  registry: TelemetryBindingsSource,
): TelemetryModule {
  const { injection } = registry.schema;

  return {
    tokens: {
      client: injection.clientKey,
      server: injection.serverKey,
      clientSymbol: TELEMETRY_CLIENT_TOKEN,
      serverSymbol: TELEMETRY_SERVER_TOKEN,
    },
    registry,
    getClient: () => registry.getClient(),
    getServer: () => registry.getServer(),
    resolveBindings() {
      const out: Record<string, TelemetryClient> = {};
      for (const [key, client] of registry.getBindings()) {
        if (typeof key === "string") out[key] = client;
      }
      return out;
    },
  };
}
